<template>
    <div class="home-page">
        <div class="home-title-wrapper">
            <div class="home-title-container">
                <h1 v-html="focus.cartouche ? focus.cartouche.titre : ''"></h1>
                <p v-html="focus.cartouche ? focus.cartouche.texte : ''"></p>
            </div>
            <img src="../../assets/images/patrimoine/Giordano Patrimoine_ Accueil en haut.jpg"/>
        </div>
        <div class="page-link-wrapper">
            <div class="page-link-container">
                <div class="flex">
                    <div>
                        <h3 v-html="focusEpargne.cartouche ? focusEpargne.cartouche.titre : ''"></h3>
                        <p v-html="focusEpargne.cartouche ? focusEpargne.cartouche.texte : ''"></p>
                        <router-link :to="{ name: 'Epargne' }">
                            <button class="cg-btn cg-btn-primary">Découvrir nos solutions</button>
                        </router-link>
                    </div>
                    <div class="img-scratch-container">
                        <img alt="" width="360px" height="auto"
                        src="../../assets/images/patrimoine/18286887_water_the_plant.jpg">
                        <div class="img-scratch img-scratch-left"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-link-wrapper">
            <div class="page-link-container">
                <div class="flex">
                    <div class="img-scratch-container">
                        <img alt="" width="360px" height="auto"
                        src="../../assets/images/patrimoine/pierres-zen-sont-arriere-plan-pyramide-galets-fond-ciel-mer-plage.jpg">
                    <div class="img-scratch img-scratch-right"></div>
                    </div>
                    <div>
                        <h3 v-html="focusIngenierie.cartouche ? focusIngenierie.cartouche.titre : ''"></h3>
                        <p v-html="focusIngenierie.cartouche ? focusIngenierie.cartouche.texte : ''"></p>
                        <router-link :to="{ name: 'Ingenierie' }">
                            <button class="cg-btn cg-btn-primary">Découvrir nos solutions</button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="home-form-wrapper">
            <div class="home-form-container">
                <h4 v-html="focusIngenierie.formulaire ? focusIngenierie.formulaire.titre : ''"></h4>
                <p v-html="focusIngenierie.formulaire ? focusIngenierie.formulaire.texte : ''"></p>
                <router-link :to="{ name: 'EtudePatrimonialeForm' }">
                    <button class="cg-btn cg-btn-primary">Quelle est votre situation ?</button>
                </router-link>
            </div>
        </div>
        <site-link siteName="Patrimoine"></site-link>
    </div>
</template>

<script>
import SiteLink from '../Components/SiteLink.vue'
import { getFocus } from '../../mixins/getFocus'

export default {
    name: 'PatrimoineHome',
    components: {
        SiteLink
    },
    mixins: [getFocus],
    data() {
        return {
            focus: {},
            focusEpargne: {},
            focusIngenierie: {}
        }
    },
    async beforeMount() {
        this.getFocus('gp', 'Accueil')
        .then(res => {
            this.focus = res
        })
        this.getFocus('gp', 'Épargne & Retraite')
        .then(res => {
            this.focusEpargne = res
        })
        this.getFocus('gp', 'Ingénierie & conseils patrimoniaux')
        .then(res => {
            this.focusIngenierie = res
        })
    }
}
</script>

<style lang="scss" scoped>
.img-scratch-container{
    position: relative;

    .img-scratch {
        background-image: url('../../assets/images/scratch.svg');
        fill: var(--color-primary);
        position: absolute;
        height: 105px;
        width: 100px;
        bottom: -40px;
    }
    .img-scratch-left {
        left: -40px;
    }
    .img-scratch-right {
        right: -40px;
    }
}

@media (max-width: 1300px) {
    .img-scratch-container{
        margin: 24px 48px 48px 48px;;

        img {
            margin: 0;
        }
    }
}
</style>